import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import CompetenciaDataService from "./services/competencia.service";
import Sidebar from './Sidebar';
import ExportSidebar from './ProSideBar';
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import { dtFormatter, dtForInputDate, PageHeader, getUserRoles } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewCompetencia extends Component {  

  constructor(props) {
    super(props);
    this.onChangeCompetencia = this.onChangeCompetencia.bind(this);
    this.onChangeCompetenciaDescription = this.onChangeCompetenciaDescription.bind(this);
    this.onChangeCompetenciaNombre = this.onChangeCompetenciaNombre.bind(this);
    this.onChangeFechaInicio = this.onChangeFechaInicio.bind(this);
    this.onChangeFechaFin = this.onChangeFechaFin.bind(this);
    this.saveCompetencia = this.saveCompetencia.bind(this);
    //this.retrieveAreasN1 = this.retrieveAreasN1.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToCompetenciasList = this.goToCompetenciasList.bind(this);

    this.state = {
      id: null,
      nombrecompetencia: "",
      descripcioncompetencia: "",
      fechainicio: "",
      fechafin: "",
      submitted: false,
      competencias: [],
      currentcompetencia: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToCompetenciasList() {
    window.location.assign('/competencias');
  }

  handleValidations() {
    if (this.state.nombrecompetencia.length==0) {
      this.setState({errmessage:'Se requiere un nombre para la competencia.'})
      this.setState({showerror:true})
      return;
    }
    this.saveCompetencia();
  } 

  refreshList() {
    // is this actually needed?
    //this.retrieveAreasN1();
    this.setState({
        currentcompetencia: null,
        currentIndex: -1
    });
  }

  onChangeCompetencia(e) {
    this.setState({
        nombrecompetencia: e.target.value
    });
  }

  onChangeCompetenciaDescription(e) {
    this.setState({
      descripcioncompetencia: e.target.value
    });
  } 

  onChangeCompetenciaNombre(e) {
    this.setState({
      nombrecompetencia: e.target.value
    });
  }   

  onChangeFechaInicio(e) {
    this.setState({
      fechainicio: e.target.value
    });
  } 
  
  onChangeFechaFin(e) {
    this.setState({
      fechafin: e.target.value
    });
  } 

  saveCompetencia() {
    var data = {
      nombrecompetencia: this.state.nombrecompetencia,
      descripcioncompetencia: this.state.descripcioncompetencia,
      fechainicio: this.state.fechainicio,
      fechafin: this.state.fechafin                
    };

    CompetenciaDataService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          nombrecompetencia: response.data.nombrecompetencia,
          descripcioncompetencia: response.data.descripcioncompetencia,
          fechainicio: response.data.fechainicio,
          fechafin: response.data.fechafin,
        });
        this.setState({showerror:false});
        this.setState({errmessage:''});
        
        this.setState({succmessage:'La competencia ha sido creada. Redirigiendo a la lista de competencias...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
        window.location.assign("/competencias");
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />       
        <Container>
          <Row className='mb-2'>
            <PageHeader/>
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Nueva Competencia</h5>
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre competencia:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombrecompetencia" id="nombrecompetencia" onChange={this.onChangeCompetenciaNombre}></FormControl>
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="fecha-inicio">Fecha inicial:</FormLabel>
              <FormControl 
                disabled={this.props.mode === 2}
                className="form-control" 
                onChange={this.onChangeFechaInicio} 
                id="fecha-inicio" 
                type="date" 
                data-date="" 
                data-date-format="DD-MM-YYYY"
                value={this.props.mode===0?null:dtForInputDate(this.state.fechainicio)}
              />
            </Col>    

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="fecha-fin">Fecha final:</FormLabel>
              <FormControl 
                disabled={this.props.mode === 2}
                className="form-control" 
                onChange={this.onChangeFechaFin} 
                id="fecha-fin" 
                type="date" 
                data-date="" 
                data-date-format="DD-MM-YYYY"
                value={this.props.mode===0?null:dtForInputDate(this.state.fechafin)}
              />
            </Col>                            

          </Row>

          <Row>
            <Col md={12}>
              <FormLabel className='mb-2'>Descripción competencia (qué incluye, cómo se llevará a cabo, etc.):</FormLabel>       
              <FormControl type="text" name="descripcioncompetencia" id="descripcioncompetencia" onChange={this.onChangeCompetenciaDescription}></FormControl>
            </Col>
          </Row>
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-4'>
              <Button id='saveItem' className='btn-secondary' onClick={this.handleValidations}>Guardar competencia</Button>            
              <Button className='m-2 btn-secondary' id='backToCompetenciasList' onClick={this.goToCompetenciasList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>  
          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )}     
          { this.state.submitted ? (<Navigate push to="/competencias"/>) : null }                                     
        </Container>
      </div>
      </>
    )      
  }
}

export default NewCompetencia;